import React from 'react';
import { Check } from 'lucide-react';

export default function WorkshopAction({ children }) {
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12, margin: '12px 0' }}>
      <Check size={18} style={{ flexShrink: 0, marginTop: 2, color: '#00613d' }} />
      <div style={{ borderLeft: '2px solid #d1fae5', paddingLeft: 12, color: '#4b5563', fontSize: '0.95rem', lineHeight: 1.7 }}>
        {children}
      </div>
    </div>
  );
}
